import { FormNodeNameType, FormNodeType } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';
import { AttendanceFlagsEditor } from './AttendanceFlagsEditor';
import { AttendanceTypeEditor } from './AttendanceTypeEditor';
import { BadgeArtSelectorEditor } from './BadgeArtSelectorEditor';
import { BadgePreviewEditor } from './BadgePreviewEditor';
import { CartEditor } from './CartEditor';
import { DealerOptionEditor } from './DealerOptionEditor';
import { DealerPiiEditor } from './DealerPiiEditor';
import { DividerEditor } from './DividerEditor';
import { EmergencyContactsEditor } from './EmergencyContactsEditor';
import { FormMarkdownEditor } from './FormMarkdownEditor';
import { LinkTermsAgreementEditor } from './LinkTermsAgreementEditor';
import { LoginEditor } from './LoginEditor';
import { OauthLoginEditor } from './OauthLoginEditor';
import { OtherOptionsEditor } from './OtherOptionsEditor';
import { PiiEditor } from './PiiEditor';
import { ProductOptionEditor } from './ProductOptionEditor';
import { ProfilePictureEditor } from './ProfilePictureEditor';
import { RandomizeButtonEditor } from './RandomizeButtonEditor';
import { SimpleLinkedTermsEditor } from './SimpleLinkedTermsEditor';
import { SubheaderEditor } from './SubheaderEditor';
import { SubmitEditor } from './SubmitEditor';
import { TermsAgreementEditor } from './TermsAgreementEditor';
import { VolunteerContactEditor } from './VolunteerContactEditor';
import { VolunteerDepartmentsEditor } from './VolunteerDepartmentsEditor';
import { VolunteerOptionEditor } from './VolunteerOptionEditor';

type AEE = AbstractElementEditor<FormNodeType>;

type EditorRecord = Readonly<Record<FormNodeNameType, AEE>>;

export const nodeEditors: EditorRecord = {
  markdown: new FormMarkdownEditor() as AEE,
  login: new LoginEditor() as AEE,
  divider: new DividerEditor() as AEE,
  subheader: new SubheaderEditor() as AEE,
  termsAgreement: new TermsAgreementEditor() as AEE,
  linkTermsAgreement: new LinkTermsAgreementEditor() as AEE,
  submit: new SubmitEditor() as AEE,
  pii: new PiiEditor() as AEE,
  attendanceType: new AttendanceTypeEditor() as AEE,
  cart: new CartEditor() as AEE,
  oauthLogin: new OauthLoginEditor() as AEE,
  text: new DividerEditor() as AEE,
  attendanceFlags: new AttendanceFlagsEditor() as AEE,
  badgeName: new DividerEditor() as AEE,
  badgePreview: new BadgePreviewEditor() as AEE,
  emergencyContacts: new EmergencyContactsEditor() as AEE,
  option: new ProductOptionEditor() as AEE,
  otherOptions: new OtherOptionsEditor() as AEE,
  profilePicture: new ProfilePictureEditor() as AEE,
  randomizeButton: new RandomizeButtonEditor() as AEE,
  dealerPii: new DealerPiiEditor() as AEE,
  simpleLinkedTerms: new SimpleLinkedTermsEditor() as AEE,
  dealerOption: new DealerOptionEditor() as AEE,
  badgeArtSelector: new BadgeArtSelectorEditor() as AEE,
  volunteerOption: new VolunteerOptionEditor() as AEE,
  volunteerContact: new VolunteerContactEditor() as AEE,
  volunteerDepartments: new VolunteerDepartmentsEditor() as AEE,
};
